/**
 * Formatações compartilhadas pelas telas de status dos dispositivos.
 *
 * As APIs devolvem códigos crus (0/1, 'ADD_PERSON', 'FALTA_NO_APARELHO') e datas como
 * 'YYYY-MM-DD HH:mm:ss'. As tabelas exportam CSV/PDF a partir do próprio item, então cada
 * tela materializa um campo `*_extenso` já traduzido — mesmo padrão de DIAGInconsistenciaDados.
 *
 * `SEM_DADO` é o que aparece quando a suite do equipamento simplesmente não fornece a
 * informação (o HikCentral não devolve o conteúdo do aparelho). Vazio ali seria ambíguo
 * com "zero pessoas no aparelho".
 */
export const SEM_DADO = '—';

export default {
  methods: {
    fmtDataHora(valor) {
      if (!valor) return '';
      const partes = String(valor).replace('T', ' ').split(' ');
      const data = (partes[0] || '').split('-');
      if (data.length !== 3) return String(valor);
      const hora = partes[1] ? ` ${partes[1]}` : '';
      return `${data[2]}/${data[1]}/${data[0]}${hora}`;
    },
    fmtSimNao(valor) {
      return valor == 1 ? this.$t('statusDispositivos.yes') : this.$t('statusDispositivos.no');
    },
    // Número que a suite não fornece vem nulo do banco e vira traço na tela.
    fmtNumero(valor) {
      return valor == null || valor === '' ? SEM_DADO : valor;
    },
    fmtTexto(valor) {
      return valor == null || String(valor).trim() === '' ? SEM_DADO : String(valor);
    },
    fmtStatusComunicacao(valor) {
      if (valor == 1) return this.$t('statusDispositivos.commStatus.online');
      if (valor == 2) return this.$t('statusDispositivos.commStatus.offline');
      return this.$t('statusDispositivos.commStatus.unknown');
    },
    corComunicacao(valor) {
      if (valor == 1) return 'green';
      if (valor == 2) return 'red';
      return 'grey';
    },
    iconeComunicacao(valor) {
      if (valor == 1) return 'mdi-check-circle';
      if (valor == 2) return 'mdi-close-circle';
      return 'mdi-help-circle';
    },
    // Resultado da última atualização do aparelho, gravado por qualquer suite.
    fmtResultadoSincronizacao(valor) {
      if (valor === 'ok') return this.$t('statusDispositivos.syncResult.ok');
      if (valor === 'erro') return this.$t('statusDispositivos.syncResult.erro');
      return this.$t('statusDispositivos.syncResult.never');
    },
    corResultadoSincronizacao(valor) {
      if (valor === 'ok') return 'green';
      if (valor === 'erro') return 'red';
      return 'blue-grey';
    },
    // Traduz um código de domínio, caindo no próprio código quando a chave não existe
    // (o banco pode ganhar valores novos antes do i18n).
    traduzDominio(dominio, codigo) {
      if (codigo == null || codigo === '') return '';
      const chave = `statusDispositivos.${dominio}.${codigo}`;
      const traduzido = this.$t(chave);
      return traduzido === chave ? String(codigo) : traduzido;
    },
  },
};
